import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import { del } from '@Domain/Api';
import documentDeleted, {
	type DocumentDeletedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentDeleted';
import documentDeletionFailed, {
	type DocumentDeletionFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentDeletionFailed';
import type DeleteDocument from '@Application/Beneficiaries/Documents/Commands/DeleteDocument';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentDeletedAction | DocumentDeletionFailedAction;

export default (command: DeleteDocument) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}`,
			);

			const action = documentDeleted(
				{ documentId: command.documentId },
				command.facilityId,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
